import { ApolloLink } from '@apollo/client';
import * as Sentry from '@sentry/react';
import { print } from 'graphql/language/printer';

const sentryBreadcrumbLink = endpoint => {
  return new ApolloLink((operation, forward) => {
    const { operationName, query } = operation;
    const queryString =
      query.loc && query.loc.source && query.loc.source.body && print(query);
    const breadcrumb = {
      category: 'graphql',
      message:
        `${endpoint}.${operationName}` +
        (queryString ? `: ${queryString}` : ''),
      level: Sentry.Severity.Info,
    };
    Sentry.addBreadcrumb(breadcrumb);

    return forward(operation);
  });
};

export default sentryBreadcrumbLink;
